import { Component } from '@angular/core';
import { StartupService } from '../services/startup.service';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {

  isAdmin = false;
  isExpanded = false;

  constructor(private ss: DataService) {
    this.isAdmin = ss._startupData.role  === 'Admin';
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
